<template>
  <div>
    <lk-table :columns='columns' :data='row.purchaseMedicineInfoVoList' class="mytable"/>
  </div>
</template>

<script>
export default {
  props: {
    row: Object,
    goodsType: {
      type: Number,
    },
  },
  computed: {
    columns() {
      const resColumns = [
        {
          title: '行号',
          width: 56,
          render: (h, { index }) => h('span', index + 1),
        },
        { title: '商品编码', key: 'purchaseMedicineDrugSerialCode', minWidth: 82 },
        { title: '通用名称', key: 'medicineInfoVoApprovedDrugNames', minWidth: 142 },
        { title: '批准文号', key: 'medicineInfoVoApprovalCode', minWidth: 116 },
        { title: '规格', key: 'medicineInfoVoSpecifications', minWidth: 130 },
        { title: '商品名称', key: 'medicineInfoVoGoodsName', minWidth: 142 },
        { title: '剂型', key: 'medicineInfoVoDosageFormString', minWidth: 116 },
        { title: '单位', key: 'purchaseMedicineDrugMinimumPackagingUnit', minWidth: 62 },
        { title: '产地', key: 'purchaseMedicineCountryOfOrigin', minWidth: 142 },
        { title: '医保编码', key: 'medicineInfoVoMedicalSerialCode', width: 200 },
        { title: '生产企业', key: 'medicineInfoVoManufacturer', minWidth: 142 },
        { title: '实收数量', key: 'purchaseReceiptInfoAcceptNum', minWidth: 82 },
        { title: '计划数量', key: 'purchaseMedicineNum', minWidth: 82 },
      ];
      if (this.goodsType === 2) {
        resColumns.splice(3, 1, {
          title: '注册证号/备案号',
          minWidth: 124,
          key: 'medicineInfoVoApprovalCode',
        });
      } else {
        resColumns.splice(3, 1, {
          title: '批准文号',
          key: 'medicineInfoVoApprovalCode',
          minWidth: 116,
        });
      }
      return resColumns;
    },
  },
};
</script>
